//state
const state = () => ({
  renderKey: 0
});

//getters
const getters = {
  getRenderKey: state => {
    return `render${Number(state.renderKey)}`;
  }
};

//mutations
const mutations = {
  SET_RENDERKEY(state, key) {
    state.renderKey = key;
  }
};

//actions
const actions = {
  setRenderKey({ commit }) {
    const key = state.renderKey + 1;
    commit("SET_RENDERKEY", { key });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
